'use strict';

import { readCookie, setCookie } from "./cookies";
import { validateForm } from "./formsValidators";
import { setUtmsInData } from "./utm";


const submitForm = (e, form, fromForm) => {
  e.preventDefault();
  return new Promise((resolve, reject) => {
    if (validateForm(form)) {
      form.classList.add('disabled');
      const newFormObj = new FormData(form);
      const phoneNumberValue = form.querySelector('.phone-number').value.trim();
      let data = {
        'name': newFormObj.get('name'),
        'email': newFormObj.get('email-input'),
        'phone': form.querySelector('.iti__selected-dial-code').innerHTML + phoneNumberValue,
        'industry': newFormObj.get('industry'),
        'acepto_politicas': (newFormObj.get('acepto_politicas') === 'on' ? true : false),
        'acepto_promociones': (newFormObj.get('acepto_promociones' === 'on') ? true : false),
        'from_form': fromForm,
        'list_id': form.getAttribute('data-list-id'),
      }

      if (phoneNumberValue === '') delete data.phone
      data = setUtmsInData(data);
      try {
        // TODO: Add await
        sentDataBackend(data, fromForm, form);
        setFunctionalityCookies(data.email, data.acepto_politicas, data.acepto_promociones);
        resolve();
      } catch (error) {
        console.error('Error en sentDataBackend:', error);
        reject(new Error('Error al enviar los datos al backend'));
      }
    } else {
      reject(new Error('Error de validación')); // Rechaza la promesa si hay un error de validación
    }
  });
};

const submitFormEsubscriber = (e, form, fromForm) => {
  e.preventDefault();
  return new Promise((resolve, reject) => {
    form.classList.add('disabled');
    let data = {
      'email': readCookie('esubscriber'),
      'list_id': form.getAttribute('data-list-id'),
      'acepto_politicas': readCookie('acepto_politicas'),
      'acepto_promociones': readCookie('acepto_promociones'),
      'from_form': fromForm
    }
    try {
      sentDataBackend(data, fromForm, form);
      resolve();
    } catch (error) {
      console.error('Error en sentDataBackend:', error);
      reject(new Error('Error al enviar los datos al backend'));
    }

  });
};

const sentDataBackend = (data, fromForm, form) => {
  const url = document.getElementById('url_home').value + '/wp-admin/admin-ajax.php';


  const formData = new FormData();

  formData.append('data', JSON.stringify(data));
  formData.append('from_form', fromForm);
  formData.append('action', 'user_register_submit');
  fetch(url, {
    method: 'POST',
    body: formData,
  })
    .then(res => res)
    .then(response => {
      form.classList.remove('disabled');
    })
    .catch(error => console.error('Error:', error));

}

const setFunctionalityCookies = (email, acceptPolicies, acceptPromotions) => {

  if (typeof OnetrustActiveGroups == 'undefined') return;

  if (OnetrustActiveGroups.includes('C0003')) {
    // Functional Cookies
    setCookie('esubscriber', email, 100000);
    setCookie('acepto_promociones', acceptPromotions, 100000);
  }

  if (OnetrustActiveGroups.includes('C0001')) {
    // Strictly neccesary cookies
    setCookie('acepto_politicas', acceptPolicies, 100000);
  }

}


export { submitForm, submitFormEsubscriber }
